<template>
  <div class="home">
    <div class="home-content">
      <img src="../assets/banner.png" alt="">
      <div class="home-content-back back1">
        <div class="home-content-text text1">
          <h3>广告策划</h3>
          <p>提供全方位的广告策划服务，帮助客户实现其品牌推广和业务增长的目标。</p>
          <div @click="handleMore('/advertisement',1)">查看更多</div>
        </div>
      </div>
      <div class="home-content-body">
        <div class="home-content-list">
          <div class="home-content-list-item" v-for="(item,index) in dataList" :key="index">
            <img :src="item.imageUrl" alt="">
            <div class="home-content-list-item-detail">
              <h3>{{item.projectName}}</h3>
              <p>{{item.projectDescribe}}</p>
              <div class="home-content-list-item-detail-bottom">
                <span>预算：{{item.projectSpendStr}}</span>
                <div @click="handleDetail(item)">查看详情</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="home-content-back back2">
        <div class="home-content-text text2">
          <h3>企业咨询</h3>
          <p>致力于为各种规模和行业的企业提供高效、创新的咨询解决方案。</p>
          <div @click="handleMore('/consult',2)">查看更多</div>
        </div>
      </div>
      <div class="home-content-body">
        <div class="home-content-list">
          <div class="home-content-list-item" v-for="(item,index) in dataList2" :key="index">
            <img :src="item.imageUrl" alt="">
            <div class="home-content-list-item-detail">
              <h3>{{item.projectName}}</h3>
              <p>{{item.projectDescribe}}</p>
              <div class="home-content-list-item-detail-bottom">
                <span>预算：{{item.projectSpendStr}}</span>
                <div @click="handleDetail(item)">查看详情</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="home-content-back back3">
        <div class="home-content-text text1">
          <h3>数字内容制作</h3>
          <p>致力于创造优质、引人入胜的数字内容，为客户提供创意和影响力。</p>
          <div @click="handleMore('/digit',3)">查看更多</div>
        </div>
      </div>
      <div class="home-content-body">
        <div class="home-content-list">
          <div class="home-content-list-item" v-for="(item,index) in dataList3" :key="index">
            <img :src="item.imageUrl" alt="">
            <div class="home-content-list-item-detail">
              <h3>{{item.projectName}}</h3>
              <p>{{item.projectDescribe}}</p>
              <div class="home-content-list-item-detail-bottom">
                <span>预算：{{item.projectSpendStr}}</span>
                <div @click="handleDetail(item)">查看详情</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="home-content-back back4">
        <div class="home-content-text text2">
          <h3>系统平台搭建</h3>
          <p>提供定制化的平台开发服务，根据需求打造功能丰富、高效的系统平台。</p>
          <div @click="handleMore('/platform',4)">查看更多</div>
        </div>
      </div>
      <div class="home-content-body">
        <div class="home-content-list">
          <div class="home-content-list-item" v-for="(item,index) in dataList4" :key="index">
            <img :src="item.imageUrl" alt="">
            <div class="home-content-list-item-detail">
              <h3>{{item.projectName}}</h3>
              <p>{{item.projectDescribe}}</p>
              <div class="home-content-list-item-detail-bottom">
                <span>预算：{{item.projectSpendStr}}</span>
                <div @click="handleDetail(item)">查看详情</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <h2>合作伙伴</h2>
    <div class="home-partners">
      <img src="../assets/partners.png" alt="">
    </div>
  </div>
</template>

<script>
import { getList } from "../utils/publish"

import ad from "../assets/ad.png"
import ad2 from "../assets/ad2.png"
import ad3 from "../assets/ad3.png"
import ad4 from "../assets/ad4.png"

import consult from "../assets/consult.png"
import consult2 from "../assets/consult2.png"
import consult3 from "../assets/consult3.png"
import consult4 from "../assets/consult4.png"

import digit from "../assets/digit.png"
import digit2 from "../assets/digit2.png"
import digit3 from "../assets/digit3.png"
import digit4 from "../assets/digit4.png"

import platform from "../assets/platform.png"
import platform2 from "../assets/platform2.png"
import platform3 from "../assets/platform3.png"
import platform4 from "../assets/platform4.png"
export default {
  name: 'HomeView', 
  data(){
    return{
      dataList:[],
      dataList2:[],
      dataList3:[],
      dataList4:[],
      options:[
        {
          label:"3万以下",
          value:"1"
        },
        {
          label:"3万-10万",
          value:"2"
        },
        {
          label:"10万-50万",
          value:"3"
        },
        {
          label:"50万以上",
          value:"4"
        },
      ],
    }
  },
  methods:{
    login(){
      this.$router.push("/login")
    },
    register(){
      this.$router.push("/register")
    },
    handleDetail(item){
      this.$store.commit("SET_ACTIVE", -1);
      this.$router.push({path:"/detail" , query: { id: item.id }})
    },
    handleMore(path,index){
      this.$store.commit("SET_ACTIVE", index);
      this.$router.push(path)
    }
  },
  activated(){
    getList().then(res => {
      // 创建图片路径映射
      const imagePaths = {
        ad: [ad, ad2, ad3, ad4],
        consult: [consult, consult2, consult3, consult4],
        digit: [digit, digit2, digit3, digit4],
        platform: [platform, platform2, platform3, platform4]
      };
      if(res.data.code == 200){
        this.dataList = res.data.data.filter(item => item.type == 1)[0].prjIntroVoList.map((item, index) => ({
          ...item,
          imageUrl: imagePaths.ad[index], // 根据类型选择对应的图片路径数组
        }));
        this.dataList2 = res.data.data.filter(item => item.type == 2)[0].prjIntroVoList.map((item, index) => ({
          ...item,
          imageUrl: imagePaths.consult[index], // 根据类型选择对应的图片路径数组
        }));
        this.dataList3 = res.data.data.filter(item => item.type == 3)[0].prjIntroVoList.map((item, index) => ({
          ...item,
          imageUrl: imagePaths.digit[index], // 根据类型选择对应的图片路径数组
        }));
        this.dataList4 = res.data.data.filter(item => item.type == 4)[0].prjIntroVoList.map((item, index) => ({
          ...item,
          imageUrl: imagePaths.platform[index], // 根据类型选择对应的图片路径数组
        }));
      }else{
        this.$message.error(res.data.message);
      }
      // console.log("res",res)
    })
  }
}
</script>
<style scoped lang="less">
.normal() {
  display: flex;
  align-items: center;
}
.fontdemo(@size,@family,@weight,@color){
  font-size:@size;
  font-family:@family;
  font-weight:@weight;
  color:@color
}
.home{
  width:100%;
  h2{
    margin: 68px auto 44px;
    font-size: 47px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    color: #000000;
    line-height: 77px;
  }
  &-top{
    .normal();
    justify-content: space-between;
    width: 100%;
    box-sizing: border-box;
    padding: 20px 37px 20px 100px;
    background: #FFFFFF;
    &-avatar{
      width: 50px;
      height: 50px;
      border-radius: 50%;
    }
    &-header{
      .normal();
      &-left{
        .normal();
        span{
          font-size: 18px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          color: #242929;
          display: inline-block;
          margin-right: 37px;
          cursor: pointer;
        }
        :last-child{
          margin-right: 0;
        }
      }
      &-right{
        .normal();
        &-bottom{
          width: 120px;
          height: 52px;
          border-radius: 8px;
          .normal();
          justify-content: center;
          cursor: pointer;
        } 
        .bottom1{
          background: #F2F2F2;
          .fontdemo(18px, 'PingFangSC,PingFang SC', 500, #000000);;
          margin-right: 18px;
          margin-left: 102px;
        }
        .bottom2{
          background: #4787F0;
          .fontdemo(18px, 'PingFangSC,PingFang SC', 500, #FFFFFF);
        }
      }
    }
  }
  &-content{
    width:100%;
    img{
      width:100%;
      height:600px;
    }
    &-back{
      width:100%;
      height:540px;
      display: flex;
    }
    &-body{
      width: 100%;
      background: #FFFFFF;
      box-sizing: border-box;
      height: 500px;
      position: relative;
    }
    &-list{
        width: calc(100% - 380px);
        position: absolute;
        top: -70px;
        left: 50%;
        transform: translateX(-50%);
        .normal();
        justify-content: space-between;
        &-item{
          width:24%;
          height: 440px;
          margin-right: 1.333%;
          box-shadow: 0px 4px 20px 0px rgba(0,0,0,0.1);
          border-radius: 12px;
          img{
            width: 100%;
            height: 200px;
          }
          &-detail{
            box-sizing: border-box;
            padding: 20px 28px 30px;
            text-align: left;
            h3{
              margin: 0;
              .fontdemo(20px, 'PingFangSC,PingFang SC', 600, #000000);
              overflow: hidden;
              text-overflow: ellipsis;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
              display: -webkit-box;
              width: 70%
            }
            p{
              .fontdemo(18px, 'PingFangSC,PingFang SC', 400, rgba(0,0,0,0.85));
              line-height: 29px;
              margin: 10px 0 20px;
              overflow: hidden;
              text-overflow: ellipsis;
              -webkit-line-clamp: 3;
              -webkit-box-orient: vertical;
              display: -webkit-box;
              height: 90px
            }
            &-bottom{
              .normal();
              justify-content: space-between;
              span{
                .fontdemo(18px, 'PingFangSC,PingFang SC', 400, rgba(0,0,0,0.5));
              }
              div{
                width: 120px;
                height: 40px;
                background: #ECF2FE;
                border-radius: 8px;
                line-height: 40px;
                text-align: center;
                .fontdemo(16px, 'PingFangSC,PingFang SC', 500, #266FE8);
                cursor: pointer;
              }
            }
          }
        }
        :last-child{
          margin-right: 0;
        }
      }
    &-text{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      h3{
        .fontdemo(47px, 'PingFangSC,PingFang SC', 600, #000000);
        margin: 0
      }
      p{
        .fontdemo(30px, 'PingFangSC,PingFang SC', 400, #000000);
        margin: 22px 0 49px;
        max-width: 700px;
        line-height: 50px
      }
      div{
        width: 154px;
        height: 52px;
        background: #4787F0;
        border-radius: 8px;
        display: flex;
        justify-content: center;
        align-items: center;
        .fontdemo(18px, 'PingFangSC,PingFang SC', 500, #FFFFFF);
        cursor: pointer;
      }
    }
    .text1{
      margin-left: 190px;
      p{
        text-align: left;
      }
    }
    .text2{
      margin-right: 190px;
      align-items: flex-end;
      p{
        text-align: right;
      }
    }
    .back1{
      background: url("../assets/background.png") no-repeat;
      background-size: cover;
    }
    .back2{
      background: url("../assets/background2.png") no-repeat;
      background-size: cover;
      justify-content: flex-end;
    }
    .back3{
      background: url("../assets/background3.png") no-repeat;
      background-size: cover;
    }
    .back4{
      background: url("../assets/background4.png") no-repeat;
      background-size: cover;
      justify-content: flex-end;
    }
  }
  &-partners{
    width: calc(100% - 144px);
    margin: 0 auto 72px;
    height: 540px;
    background: #ECF2FE;
    box-sizing: border-box;
    padding:78px 118px;
    img{
      width: 100%;
      height: 100%;
    }
  }
}
</style>
